<template>
    <fb-form-body>
        <el-form :model="formData" :rules="rules" ref="form" label-width="130px">

            <el-form-item label="设备SN" prop="sn" :error="formErrorMsg.sn" class="fb-form-item">
                <el-input v-model="formData.sn" placeholder="设备SN" disabled></el-input>
            </el-form-item>

            <el-form-item label="设备编号" prop="number" :error="formErrorMsg.number" class="fb-form-item">
                <el-input v-model="formData.number" placeholder="设备编号" :disabled="formData.autoNum" disabled></el-input>
            </el-form-item>

            <el-form-item label="厂商标识" prop="mfg" :error="formErrorMsg.mfg" class="fb-form-item">
                <dict-select type-flag="SPDEV_MFG" v-model="formData.mfg" clearable></dict-select>
            </el-form-item>

            <el-form-item label="设备状态" prop="status" :error="formErrorMsg.status" class="fb-form-item">
                <dict-select type-flag="SPDEV_STATUS" v-model="formData.status" clearable></dict-select>

            </el-form-item>

            <el-form-item label="流量卡号" class="fb-form-item">
                <el-input v-model="formData.simNo" placeholder="流量卡号"></el-input>
            </el-form-item>


            <el-form-item>
                <el-button type="primary" @click="handleSubmit('form')">确定</el-button>
                <el-button @click="handleReset('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </fb-form-body>
</template>

<script>


    export default {
        name: "SpdeviceEdit",
        components: {},
        data() {
            return {
                api:{
                   update:this.$api.spDevice.update,
                   detail:this.$api.spDevice.detail,
                },
                formErrorMsg:{
                    sn: '',
                    number: '',
                    mfg: '',
                    autoNum:'',
                    status: ''
                },
                formData: {
                    code:'',
                    sn: '',
                    number: '',
                    mfg: '',
                    autoNum:'',
                    status: '',
                    simNo:''
                },
                rules: {
                    sn: [
                        {required: true, message: '请输入设备SN码', trigger: 'blur'},
                    ],
                    mfg: [
                        {required: true, message: '请输入设备厂商标识', trigger: 'blur'},
                    ],
                    status: [
                        {required: true, message: '请选择设备状态', trigger: 'blur'},
                    ]
                }
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                if(resp.data.data.errorFields){
                                    resp.data.data.errorFields.forEach(function (a) {

                                        vm.formErrorMsg[a.name] = '';
                                        vm.$nextTick(() => {
                                            vm.formErrorMsg[a.name] = a.message;
                                        });
                                    });
                                }

                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                for(let key in resp.data.data){
                    for(let fKey in vm.formData){
                        vm.formData[fKey] = resp.data.data[key][fKey];
                    }
                }
            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>


<style>

    .editor-item{
         position: relative;
    }

    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>